module.exports = __webpack_public_path__ + "img/pdf.8ab6cac3.svg";